import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Report } from "ng/src/app/reports/report.model";
import { AlertTriggerBuilderScope } from "ng/src/app/reports/upgrade/alert-trigger-builder-upgrade.component";
import { Template } from '../shared/template.model';
import { Defer } from "ng/src/app/core/defer";
import { LogService } from "ng/src/app/logs/log.service";

/**
 * This component is used to bridge AJS upgraded AlertTriggerBuilderUpgrade Component to Angular only.
 * Once report editor is moved to Angular, this component should be removed.
 */
@Component({
	selector: 'lb-trigger-editor[report][template]',
	template: `
		<lb-alert-trigger-builder-upgrade [selectedLog]="selectedLog" [template]="template" [report]="report" [onBind]="onBindUpgrade"></lb-alert-trigger-builder-upgrade>
		<p-dialog appendTo="body" [modal]="true" [visible]="saving" [closable]="false" [draggable]="false" [resizable]="false">
			<lb-loading-indicator label="Saving your changes"></lb-loading-indicator>
		</p-dialog>
	`
})
export class AlertTriggerEditorComponent {
	@Input() report!: Report;
	@Input() template!: Template;
	
	@Output() onDismiss = new EventEmitter();
	
	onBindUpgrade = this.getOnBindUpgrade();
	boundScope?: AlertTriggerBuilderScope;
	boundPromise = new Defer<AlertTriggerBuilderScope>();
	
	saving = false;
	
	get selectedLog() {
		return LogService.selectedLog!;
	}
	
	getOnBindUpgrade() {
		const self = this;
		return function(scope: AlertTriggerBuilderScope) {
			self.boundScope = scope;
			self.boundPromise.resolve(scope);
		}
	}
	
	dismiss(save: boolean) {
		return Promise.resolve(save ? this.save() : Promise.resolve())
			.then(() => {
				this.onDismiss.emit();
			})
	}
	
	save() {
		this.saving = true;
		return this.boundPromise.promise
			.then(scope => {
				return scope.saveAll();
			})
			.finally(() => this.saving = false);
	}
}